import ShopAccountListPage from '.';

export default {
    shopAccountListPage: {
        path: '/shop-accounts',
        title: 'Shop Account',
        auth: true,
        component: ShopAccountListPage,
        // permission: [apiConfig.news.getList.baseURL],
    },
};
